import { IPublicEnumDragObjectType } from '@rchh/lowcode-types';
import { isObject } from '../is-object';
export function isDragNodeObject(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return obj.type === IPublicEnumDragObjectType.Node;
}